export default __webpack_public_path__ + "static/media/face_roller.4105b763.jpg";